import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { MENU_TYPES } from 'constants/menuManagement';

// eslint-disable-next-line no-use-before-define
MenuEdit.Context = React.createContext();

function MenuEdit({ children, menu, ...rest }) {
  const isCateringMenu = menu?.menuType === MENU_TYPES.CATERING;
  const [photoFetchKey, setPhotoFetchKey] = useState(0);
  const [imageOverrides, setImageOverrides] = useState({});
  const [itemsFetchKey, setItemsFetchKey] = useState(0);
  const [hasHoursErrors, setHasHoursErrors] = useState(false);

  return (
    <MenuEdit.Context.Provider
      value={{
        menu,
        isCateringMenu,
        ...rest,
        photoFetchKey,
        refetchPhotos: () => setPhotoFetchKey(k => k + 1),
        imageOverrides,
        setImageOverride: (uuid, url) => setImageOverrides(prev => ({ ...prev, [uuid]: url })),
        itemsFetchKey,
        refetchItems: () => setItemsFetchKey(k => k + 1),
        hasHoursErrors,
        setHasHoursErrors,
      }}
    >
      {children}
    </MenuEdit.Context.Provider>
  );
}
MenuEdit.propTypes = {
  children: PropTypes.node,
  menu: PropTypes.shape({
    menuType: PropTypes.string,
  }),
};

export default MenuEdit;
